export default __webpack_public_path__ + "assets/_Chapters/Karriere/SSV-Kroschke/ssv-innenausstattung.webp";